import {
  ArrayInput,
  DateTimeInput,
  Edit,
  FormDataConsumer,
  SelectInput,
  SimpleForm,
  SimpleFormIterator,
  TextInput,
  BooleanInput,
  AutocompleteInput,
  ReferenceInput,
} from "react-admin";

import { validate } from "./validation";
import { Grid } from "@mui/material";

import VersionList from "./VersionList";
import { customComponentsTypesOptions } from "../customComponentsTypes";

const format = v => (v ? v : "");
const parse = v => (v ? v : null);

const getVersionList = formData => {
  return formData.versions
    ? formData.versions
        .filter(version => {
          return !version.isDraft;
        })
        .map(version => ({
          id: version.id,
          name: `${version.name || ""} ID_${version.id}`,
        }))
    : [];
};

const EditVersionObject = ({ mode }) => {
  let title;
  let isPage;

  switch (mode) {
    case "page":
      title = "Редактиране на страница";
      isPage = true;
      break;
    case "component":
      title = "Редактиране на компонент";
      isPage = false;
      break;
    default:
  }

  return (
    <Edit
      title={title}
      mutationMode="pessimistic"
      mutationOptions={{ meta: { useFormData: false } }}
    >
      <SimpleForm validate={values => validate(values, isPage)}>
        <FormDataConsumer>
          {({ formData }) => {
            // console.log(formData);
            return (
              <Grid
                container
                spacing={5}
              >
                <Grid
                  item
                  xs={12}
                  sm={5}
                  lg={4}
                >
                  <TextInput
                    disabled
                    source="id"
                    fullWidth
                  />

                  <TextInput
                    source="name"
                    label="Име"
                    fullWidth
                  />

                  {isPage ? (
                    <TextInput
                      source="route"
                      label="Адрес"
                      fullWidth
                    />
                  ) : (
                    <SelectInput
                      label="Тип"
                      source="componentTypeName"
                      choices={customComponentsTypesOptions}
                      fullWidth
                    />
                  )}

                  <SelectInput
                    source="activeVersionId"
                    label="Текуща(активна) весия"
                    parse={parse}
                    format={format}
                    choices={getVersionList(formData)}
                    fullWidth
                  />

                  <SelectInput
                    source="futureActiveVersion.id"
                    label="Бъдеща версия"
                    parse={parse}
                    format={format}
                    choices={getVersionList(formData)}
                    fullWidth
                  />

                  <DateTimeInput
                    source="futureActiveVersion.activeFrom"
                    label="Начална дата на бъдеща версия"
                    fullWidth
                  />

                  <ArrayInput
                    source="temporaryVersions"
                    label="Временни версии"
                    fullWidth
                  >
                    <SimpleFormIterator>
                      <SelectInput
                        source="id"
                        label="Версия"
                        parse={parse}
                        format={format}
                        choices={getVersionList(formData)}
                        fullWidth
                      />
                      <DateTimeInput
                        source="activeFrom"
                        label="Активна от"
                        fullWidth
                      />
                      <DateTimeInput
                        source="activeTo"
                        label="Активна до"
                        fullWidth
                      />
                    </SimpleFormIterator>
                  </ArrayInput>

                  {isPage && (
                    <>
                      <ReferenceInput
                        reference={"languages-cms"}
                        source="languageId"
                        queryOptions={{ meta: { mixed_provider: true } }}
                      >
                        <AutocompleteInput
                          label="Език"
                          filterToQuery={q => ({ language: q })}
                          optionText={"language"}
                          fullWidth
                        />
                      </ReferenceInput>
                      <p className="">SEO</p>
                      <BooleanInput
                        defaultValue={true}
                        source="hasIndex"
                        label="Индексиране?"
                      />

                      <TextInput
                        source="title"
                        label="Мета заглавие"
                        fullWidth
                      />

                      <TextInput
                        source="description"
                        label="Мета описание"
                        fullWidth
                      />

                      <TextInput
                        source="canonicalTag"
                        label="Каноникал таг"
                        fullWidth
                      />
                    </>
                  )}
                </Grid>
                <VersionList
                  mode={mode}
                  pageName={formData.name}
                  route={formData.route}
                  activeVersionId={formData.activeVersionId}
                  futureActiveVersion={formData.futureActiveVersion?.id}
                  temporaryVersions={formData.temporaryVersions}
                />
              </Grid>
            );
          }}
        </FormDataConsumer>
      </SimpleForm>
    </Edit>
  );
};

export default EditVersionObject;
